import React from 'react';
import MovdButton from './MovdButton.jsx';

// Consistent CTA placement for every stage: primary continue action on the
// left (start of reading order), optional secondary text links trailing.
export default function MovdFormActions({ primaryLabel, onPrimary, primaryEndIcon, secondary, style }) {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 16, marginTop: 24, ...style }}>
      <MovdButton onClick={onPrimary}>
        {primaryLabel}
        {primaryEndIcon}
      </MovdButton>
      {secondary}
    </div>
  );
}
